module.exports = __webpack_public_path__ + "img/anonimo.281ea875.jpg";